import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { BadgeView } from './components/BadgePopup';
import { BadgeView as DarkBadgeView } from './components/DarkBadgePopup';
import AccentTextView from './views/AccentTextView';
import ButtonView from './views/ButtonView';
import WhiteTextView from './views/WhiteTextView';
import DarkAccentTextView from './views/DarkAccentTextView';

import { badgeExists } from './helper/badgeExists';
import { parseBadge } from './helper/parseBadge';

class ViewBadge extends Component {
  static contextTypes = {
    getCurrentUserInfo: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      showBadge: false
    };
  }

  renderBadgePopup = (badgeData, show, isMobile) => {
    if (show) {
      return (
        <DarkBadgeView
          badge={badgeData}
          show={show}
          onClose={this.handleCloseBadge}
          isMobile={isMobile}
        />
      );
    }
    return null;
  };

  handleViewBadge = event => {
    event.stopPropagation();
    event.preventDefault();
    this.setState({
      showBadge: true
    });
  };

  handleCloseBadge = event => {
    event.stopPropagation();
    event.preventDefault();
    this.setState({ showBadge: false });
  };

  render() {
    const { type, badgeData, isMobile } = this.props;
    const components = {
      AccentTextView,
      ButtonView,
      WhiteTextView,
      DarkAccentTextView
    };
    const ViewComponent = components[type];

    return (
      <div onClick={e => e.stopPropagation()} role="presentation">
        <ViewComponent handleClick={this.handleViewBadge} />
        {this.renderBadgePopup(badgeData, this.state.showBadge, isMobile)}
      </div>
    );
  }
}

ViewBadge.propTypes = {
  type: PropTypes.oneOf(['AccentTextView', 'ButtonView', 'WhiteTextView', 'DarkAccentTextView'])
    .isRequired
};

export { BadgeView, badgeExists, parseBadge };
export default ViewBadge;
